import { Stack } from '@mui/material';

import { useOriginClick } from 'services/datalayer/browse';
import { CollectionFragment } from 'types/api/dato-operations.types';

import CollectionCard from 'components/@collections/CollectionCard';
import ScrollableList from 'components/@lists/ScrollableList';

interface Props {
  collections?: Array<CollectionFragment>;
}

const HomeCollections = ({ collections }: Props) => {
  const handleClick = useOriginClick('Collections', 'Discover');

  if (!collections?.length) {
    return null;
  }

  return (
    <Stack
      sx={{
        mb: { xs: 8, md: 15 },
      }}
    >
      <ScrollableList
        minWidthItem={{ xs: 140, md: 176 }}
        imageRefHeight={104}
        gap={1}
      >
        {collections.map((collection) => (
          <CollectionCard
            key={collection.id}
            title={collection.title}
            count={collection.references.count}
            slug={collection.slug}
            onClick={handleClick}
          />
        ))}
      </ScrollableList>
    </Stack>
  );
};

export default HomeCollections;
